module.exports = __webpack_public_path__ + "img/good-question.6096d18e.svg";